(function () {
    'use strict';

    var ItxWorldWideCmp = {
        controllerAs: '$ctrl',
        templateUrl: 'world-wide.component.html',
        controller: ItxWorldWideCmpCtrl,
        bindings: {
            storeList: '<',
            goTo: '&'
        }
    };

    ItxWorldWideCmpCtrl.$inject = [
        '$timeout',
        '$window',
        '$scope',
        'ItxScreenSizeSvc',
        'homeManagerSvc',
        'ItxStaticResourceSvc',
        'ItxHeaderFct',
        'ItxLoaderFct',
        'timestampSvc',
        '$http',
        'logger',
        '$q',
        'wwTranslationSvc',
        'NavigationService',
        'DUTTI_CONS',
        'homeRedirectSvc'
    ];

    function ItxWorldWideCmpCtrl(
        $timeout,
        $window,
        $scope,
        ItxScreenSizeSvc,
        homeManagerSvc,
        ItxStaticResourceSvc,
        ItxHeaderFct,
        ItxLoaderFct,
        timestampSvc,
        $http,
        logger,
        $q,
        wwTranslationSvc,
        NavigationService,
        DUTTI_CONS,
        homeRedirectSvc
    ) {
        var _this = this;

        _this.$window = $window;

        _this.ItxScreenSizeSvc = ItxScreenSizeSvc;
        _this.selectedStore = null;
        _this.showSection = true;
        _this.selectedLanguage = null;
        _this.searchCountry = '';
        _this.isMobile = false;

        _this.showVideo = false;

        _this.selectOpen = '';

        _this.$onInit = function () {
            $('html').addClass('new-ww');

            let url =
                ItxStaticResourceSvc.getStatic() +
                '/media/2020/worldwide/ww_video.mp4?t=' +
                timestampSvc.getTs();
            checkVideoExists(url);

            _this.setContinents();
            // SET SCREEN MOBILE
            if (inditex.isMobileDevice()) {
                _this.isMobile = true;
                // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
                var vh = window.innerHeight * 0.01;
                // Then we set the value in the --vh custom property to the root of the document
                //document.documentElement.style.setProperty('--vh', `${vh}px`);
                document.documentElement.style.setProperty('--vh', ''.concat(vh, 'px'));

                // We listen to the resize event
                window.addEventListener('resize', function () {
                    // We execute the same script as before
                    var vh = window.innerHeight * 0.01;
                    //document.documentElement.style.setProperty('--vh', `${vh}px`);
                    document.documentElement.style.setProperty('--vh', ''.concat(vh, 'px'));
                });
            }
            // SET SCREEN MOBILE

            _this.texts = inditex.properties;

            _this.image_bg = {
                path: ItxStaticResourceSvc.getStatic() + '/media/2020/worldwide/',
                name: 'bg_section',
                format: 'jpg',
                priority: 1
            };
            _this.image_ww = {
                path: ItxStaticResourceSvc.getStatic() + '/media/2020/worldwide/',
                name: 'ww_image',
                format: 'jpg',
                priority: 1
            };

            _this.setTexts();
            _this.logoPath = ItxStaticResourceSvc.getImage('logo.png');
        };

        _this.$onChanges = function () {
            _this.setContinents();
            if (_this.storeList && _this.storeList.length) {
                _this.accordionObject = _(_this.storeList)
                    .groupBy('continent')
                    .map(function(items, continent ){
                        return{
                            header: _this.getContinentById(continent),
                            id:  _this.getContinentId(continent),
                            children:  _.map(items, function(el){
                                return {
                                    header: el['countryName'],
                                    icon: (el['isOpenForSale'] || el['redirectToWorldWide']  ? 'linicon-bag': '' ),
                                    children: _.map(el['supportedLanguages'], function(el){
                                            return{
                                                header: el['name']
                                            };
                                    })
                                };
                            })
                        };
                    })
                    .value();
                                        
                _this.preselect();
            }
        };

        /**
         * Función para obtener el listado de continentes traducidos
         */
        _this.setContinents = function () {
            _this.continents = wwTranslationSvc.getContinents(
                _this.selectedLanguage ? _this.selectedLanguage.id : '-1'
            );
        };

        _this.getContinentById = function (id) {
            var region = _.find(_this.continents, function (continent) {
                return continent.continent == id;
            });
            if (region) {
                return region.description;
            } else {
                console.error('Region not found with id: ' + id);
            }
        };

        _this.getContinentId = function (id) {
            var region = _.find(_this.continents, function (continent) {
                return continent.continent == id;
            });
            if (region) {
                return region.id;
            } else {
                console.error('Region not found with id: ' + id);
            }
        };

        _this.showLangs = function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (e.target.nodeName !== 'A') {
                return;
            }
            TweenMax.to(document.querySelectorAll('.ww-countries-langs'), 0.3, {
                top: '24px',
                height: '0px',
                ease: 'easeOutSine'
            });
            var target = e.currentTarget.lastElementChild;
            TweenMax.to(target, 0.3, {
                top: '24px',
                height: '255px',
                ease: 'easeOutSine'
            });
        };

        _this.collapseLangs = function (e) {
            if (e.toElement && e.toElement.className === 'ww-countries-langs') {
                return;
            }
            e.stopPropagation();
            e.preventDefault();

            var target = e.currentTarget.lastElementChild;
            TweenMax.to(target, 0.2, {
                height: '0px',
                ease: 'easeOutSine'
            });
        };

        _this.hoverRegion = function (e) {
            //animaciÃ³n de accordion con tweenmax, sin delays
            if (!e.currentTarget.classList.contains('active')) {
                TweenMax.to(e.currentTarget.querySelector('.ww-bar'), 0.2, {
                    height: '2px',
                    ease: 'easeOutSine'
                });
            }
        };

        _this.cleanRegion = function (e) {
            if (!e.currentTarget.classList.contains('active')) {
                TweenMax.to(e.currentTarget.querySelector('.ww-bar'), 0.2, {
                    height: '0px',
                    ease: 'easeOutSine'
                });
            }
        };

        _this.selectRegion = function (e) {
            e.preventDefault();
            var $continent = e.currentTarget.querySelector('.ww-regions-btn').getAttribute('id');
            var $regionsBar = e.currentTarget.querySelector('.ww-bar');
            angular.element('.ww-regions').removeClass('active');

            document.querySelector('.ww-content-desktop').className = 'ww-content-desktop';
            e.currentTarget.classList.add('active');

            document.querySelector('.ww-content-desktop').classList.add('is-' + $continent);

            TweenLite.to(document.querySelectorAll('.ww-bar'), 0.2, {
                backgroundColor: '#000',
                height: '0',
                ease: Power2.easeOut
            });

            TweenLite.to($regionsBar, 0.2, {
                backgroundColor: '#000',
                height: '100%',
                ease: Power2.easeOut
            });

            // scroll to si hacemos click en continentes TweenMax.to($window, 1, {
            //     scrollTo:{
            //         y: 375,
            //         autoKill: true
            //     },
            //     ease:Power3.easeOut
            // });
        };

        _this.setImageBackground = function (img) {
            var size = 6;
            if (ItxScreenSizeSvc.is('md')) {
                size = 4;
            } else if (ItxScreenSizeSvc.is('sm')) {
                size = 4;
            } else if (ItxScreenSizeSvc.is('xs')) {
                size = 2;
            }
            var url =
                img.path + img.name + '_' + size + '.' + img.format + '?t=' + inditex.iRegistryTs;

            return {
                'background-image': 'url(' + url + ')'
            };
        };

        _this.selectCountryByName = function (data) {
            _this.selectedStore = _.find(_this.storeList, function (store) {
                return store.countryName === data.children;
            });
            if (_this.selectedStore) {
                _this.selectedLanguage = _.find(_this.selectedStore.supportedLanguages, function (
                    lang
                ) {
                    return data.subItem === lang.name;
                });
            }
            _this.selectStore(_this.selectedStore);
        };

        _this.toggleSelect = function (id) {
            if (id === 'close') {
                _this.selectOpen = '';
            } else {
                if (_this.selectOpen === id) {
                    _this.selectOpen = '';
                } else {
                    _this.selectOpen = id;
                }
            }
        };

        _this.selectStore = function (store, hasSearch) {
            _this.searchCountry = '';
            _this.selectedStore = store;
            if ((!_this.selectedLanguage || hasSearch) && _this.selectedStore) {
                _this.selectedLanguage = _this.selectedStore.supportedLanguages[0];
            }

            var storeId = '38009450';
            if (store && store.id) {
                storeId = store.id;
            }
            $http
                .get(
                    window.staticContent +
                        'configurations/properties-' +
                        storeId +
                        '.json?t=' +
                        timestampSvc.getTs()
                )
                .then(function (response) {
                    _this.configuration = eval(response.data);
                    window.configurationContent.properties = _this.configuration;
                    _this.toggleSelect('close');
                    _this.checkSectionsActive();
                    _this.setTexts();
                    _this.setContinents();
                    _this.showSection = true;
                })
                .finally(function () {});
        };

        _this.selectLanguage = function (language) {
            _this.toggleSelect('close');
            _this.selectedLanguage = language;
            _this.setTexts();
            _this.setContinents();
        };

        _this.setTexts = function () {
            _this.text = wwTranslationSvc.getWWTranslate(
                _this.selectedLanguage ? _this.selectedLanguage.id : '-1'
            );
        };

        _this.selectSection = function (section) {
            _this.section = section;
            _this.goStore();
        };

        //Event for closing on click outside
        $(document).mouseup(function (e) {
            $('.ww-box-select').each(function () {
                var container = $(this),
                    wrapper = $(this).closest('.ww-box').find('.ww-box-wrapper'),
                    id = container.attr('data-id');
                if (!container.has(e.target).length && !wrapper.is(e.target.parentNode)) {
                    if (_this.selectOpen === id) {
                        _this.toggleSelect('close');
                        $timeout();
                    }
                }
            });
        });

        /**
         * Select store and continue to the shop
         * @param {Store} store - The ITX Store
         * @param {Language} language - The ITX Language
         */
        _this.goStore = function (click) {
            logger.log(
                'goStore ',
                !_this.selectedStore || !_this.selectedLanguage || !_this.section
            );

            // QA Temporal - Eliminar después de pruebas
            /* if(_this.selectedStore.countryCode === 'DE') {
                $('body').addClass('is-rtl');
                $('body,html').attr("dir","rtl");
            } */

            /* if (_this.selectedLanguage.id === -44) {
                $('body').addClass('is-rtl');
                $('body,html').attr('dir', 'rtl');
            } */

            if (!_this.selectedStore || !_this.selectedLanguage || !_this.section) {
                //no hacemos nada..
                return;
            }

            //this.$window.location.href = inditex.encodeStoreUrl(store, language.id, true);

            // IMAnalytics Vista WorldWide
            _this.goTo({
                store: _this.selectedStore,
                language: _this.selectedLanguage,
                section: _this.section
            });
        };

        /**
         * Preselect store based on Geolocation of the current user
         */
        _this.preselect = function () {
            _this.preselectStore();
            _this.preselectSection();
        };

        _this.preselectStore = function () {
            var _this = this;
            var lastStore = homeManagerSvc.getLastStore(true);
            if (lastStore) {
                // If last store is WW, WY, WZ, WA or WE find story by ISO code
                if ([ 38009450, 38009451, 38009452, 38009453, 38009454 ].indexOf( lastStore.storeId ) > 0 ) { 
                    var isoCode = inditex.getLocalStorage('COUNTRY_ISO');
                    _this.selectedStore = _.find(_this.storeList, function (store) {
                        return isoCode === store.countryCode;
                    });
                } else {
                    _this.selectedStore = _.find(_this.storeList, function (store) {
                        return lastStore.storeId === store.id;
                    });
                }

                if (_this.selectedStore) {
                    _this.selectedLanguage = _.find(
                        _this.selectedStore.supportedLanguages,
                        function (lang) {
                            return lastStore.langId === lang.id;
                        }
                    );
                }
                _this.selectStore(_this.selectedStore);
            }
            if (!_this.selectedStore && angular.isDefined(inditex.iGeoLocationJSON)) {
                var countryCode = inditex.iGeoLocationJSON['country_code'];

                for (var i = 0; i < _this.storeList.length; i++) {
                    if (_this.storeList[i].countryCode === countryCode) {
                        _this.selectedStore = _this.storeList[i];
                        _this.selectedLanguage = _this.storeList[i].supportedLanguages[0];
                        _this.selectStore(_this.selectedStore);
                    }
                }
            }
        };

        _this.preselectSection = function () {
            _this.section = ItxHeaderFct.getLastSection();
        };

        _this.checkSectionsActive = function () {
            _this.setElements(2);
        };

        _this.setElements = function (elements) {
            var el = $('.js-ma-ww-col-dinamic');
            if (elements === 2) {
                _this.isBgActive = false;
                _this.isWomenActive = true;
                _this.isMenActive = true;
                $timeout(function () {
                    document.body.classList.add('ww-two-box');
                    el = $('.js-ma-ww-col-dinamic');
                    el.removeClass('col-sm-4');
                    el.addClass('col-sm-6');
                }, 500);
            } else {
                el.removeClass('col-sm-6');
                el.addClass('col-sm-4');
                document.body.classList.remove('ww-two-box');
                $timeout(function () {
                    _this.isWomenActive = true;
                    _this.isMenActive = true;
                    _this.isBgActive = true;
                }, 500);
            }
        };

        function checkVideoExists(url) {
            var http = new XMLHttpRequest();
            http.open('HEAD', url);
            http.onreadystatechange = function () {
                if (this.readyState == this.DONE) {
                    if (this.status == 200) {
                        _this.showVideo = true;
                        _this.urlVideo = url;
                    }
                }
            };
            http.send();
        }
    }

    angular.module('itxApp.home').component('worldWide', ItxWorldWideCmp);
})();
